import { initializeApp } from 'firebase/app'
import { getFirestore, collection, getDocs, onSnapshot, addDoc, deleteDoc, doc, query, where, orderBy, serverTimestamp, updateDoc } from 'firebase/firestore'
import { getAuth, createUserWithEmailAndPassword, signInWithEmailAndPassword, signOut, onAuthStateChanged } from 'firebase/auth'

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTHDOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
}

// init firebase
initializeApp(firebaseConfig)

// init services
export const db = getFirestore()
export const auth = getAuth()

// collection ref
// const colRef = collection(db, 'clients')
// getDocs(colRef)
//   .then(snapshot => {
//     console.log(snapshot.docs)
//     let books = []
//     snapshot.docs.forEach(doc => {
//       books.push({ ...doc.data(), id: doc.id })
//     })
//     console.log(books)
//   })
//   .catch(err => {
//     console.log(err.message)
//   })






// // queries
// const q = query(colRef, where("author", "==", "patrick rothfuss"), orderBy('createdAt'))

// // realtime collection data
// const unsubCol = onSnapshot(q, (snapshot) => {
//   let books = []
//   snapshot.docs.forEach(doc => {
//     books.push({ ...doc.data(), id: doc.id })
//   })
//   console.log(books)
// })


// // adding docs
// const addBookForm = document.querySelector('.add')
// addBookForm.addEventListener('submit', (e) => {
//   e.preventDefault()

//   addDoc(colRef, {
//     title: addBookForm.title.value,
//     author: addBookForm.author.value,
//     createdAt: serverTimestamp()
//   })
//     .then(() => {
//       addBookForm.reset()
//     })
// })

// // deleting docs
// const deleteBookForm = document.querySelector('.delete')
// deleteBookForm.addEventListener('submit', (e) => {
//   e.preventDefault()

//   const docRef = doc(db, 'books', deleteBookForm.id.value)

//   deleteDoc(docRef)
//     .then(() => {
//       deleteBookForm.reset()
//     })
// })

// // fetching a single document (& realtime)
// const docRef = doc(db, 'books', 'gGu4P9x0ZHK9SspA1d9j')

// const unsubDoc = onSnapshot(docRef, (doc) => {
//   console.log(doc.data(), doc.id)
// })

// // updating a document
// const updateForm = document.querySelector('.update')
// updateForm.addEventListener('submit', (e) => {
//   e.preventDefault()

//   let docRef = doc(db, 'books', updateForm.id.value)

//   updateDoc(docRef, {
//     title: 'updated title'
//   })
//     .then(() => {
//       updateForm.reset()
//     })
// })

// // signing users up
// const signupForm = document.querySelector('.signup')
// signupForm.addEventListener('submit', (e) => {
//   e.preventDefault()

//   const email = signupForm.email.value
//   const password = signupForm.password.value

//   createUserWithEmailAndPassword(auth, email, password)
//     .then(cred => {
//       console.log('user created:', cred.user)
//       signupForm.reset()
//     })
//     .catch(err => {
//       console.log(err.message)
//     })
// })

// // logging in and out
// const logoutButton = document.querySelector('.logout')
// logoutButton.addEventListener('click', () => {
//   signOut(auth)
//     .then(() => {
//       console.log('user signed out')
//     })
//     .catch(err => {
//       console.log(err.message)
//     })
// })

// const loginForm = document.querySelector('.login')
// loginForm.addEventListener('submit', (e) => {
//   e.preventDefault()

//   const email = loginForm.email.value
//   const password = loginForm.password.value

//   signInWithEmailAndPassword(auth, email, password)
//     .then(cred => {
//       console.log('user logged in:', cred.user)
//       loginForm.reset()
//     })
//     .catch(err => {
//       console.log(err.message)
//     })
// })

// // subscribing to auth changes
// const unsubAuth = onAuthStateChanged(auth, (user) => {
//   console.log('user status changed:', user)
// })

// // unsubscribing from changes (auth & db)
// const unsubButton = document.querySelector('.unsub')
// unsubButton.addEventListener('click', () => {
//   console.log('unsubscribing')
//   unsubCol()
//   unsubDoc()
//   unsubAuth()
// })